const TrunkType = {
    OPERATOR_CONNECT: '9bcaa351-df28-4457-32b4-08d9e15f3200',
    DIRECT_ROUTING: '',
};

export default TrunkType;
